module.exports = __webpack_public_path__ + "img/3.fd31d94e.png";